import { TELEMETRY_EVENT_NAMES } from '../telemetry-events.constants'
import { TelemetryIntegration } from '../telemetry-events.types'

import { getColorwayId } from './provider-utils/stylitics-utils'

const PLACEMENT = 'main'
const STYLITICS_CLIENT = 'quince'
export const Stylitics: TelemetryIntegration = {
  config: {
    enabled: true,
    eventIdealTimeout: 1000,
  },
  initialize: async () => {
    try {
      /* eslint-disable import/no-unresolved, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-ts-comment */
      // @ts-ignore
      const StyliticsInsightsModule: any = await import(
        /* @vite-ignore */ /* webpackIgnore: true */ 'https://web-assets.stylitics.com/insights-script/latest/stylitics-insights-script.js'
      )
      /* eslint-enable import/no-unresolved, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-ts-comment */
      const StyliticsInsights = StyliticsInsightsModule.default || StyliticsInsightsModule
      const insights = await StyliticsInsights.create({
        client: STYLITICS_CLIENT,
      })
      window.StyliticsInsights = insights as typeof window.StyliticsInsights
    } catch (err) {
      console.error('Failed to init Stylitics Insights', err)
    }
  },
  events: {
    [TELEMETRY_EVENT_NAMES.ADD_TO_CART](properties) {
      const productId = properties.productId
      const selectedColor = properties.productProperties?.color

      const colorwayId = getColorwayId(productId, selectedColor)
      const price = properties.price
      window.StyliticsInsights?.trackAddItemToCart?.({
        itemId: colorwayId,
        placement: PLACEMENT,
        price: Number(price),
        quantity: properties.quantity,
      })
    },
    [TELEMETRY_EVENT_NAMES.STYLITICS_ITEM_VIEW](properties) {
      const { itemObject, itemImageType, position } = properties
      window.StyliticsInsights?.trackItemView?.({
        item: itemObject,
        itemImageType,
        position,
      })
    },
    [TELEMETRY_EVENT_NAMES.STYLITICS_ITEM_CLICK](properties) {
      const { itemObject, placement, position } = properties
      window.StyliticsInsights?.trackItemClick?.({
        item: itemObject,
        placement,
        position,
      })
    },
  },
}
